export const VERSION = "2.4.1";

export const stringDateFormat = "yyyy-MM-dd";
